var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiLogo = function SvgFiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1a1a1a",
    d: "M0 0h192v192H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00e3bb",
    d: "M132 0h24v48H36V24h96Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce6b23",
    d: "M36 48h120v48H36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00cbef",
    d: "M108 96h48v48H36v-24h72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2b468",
    d: "M36 144h120v48H36z"
  })));
};
export { SvgFiLogo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIgMTkyIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIj4KICA8IS0tIEJhY2tncm91bmQgLS0+CiAgPHJlY3Qgd2lkdGg9IjE5MiIgaGVpZ2h0PSIxOTIiIGZpbGw9IiMxYTFhMWEiLz4KICAKICA8IS0tIE1pbnQgR3JlZW4gVG9wIEJsb2NrIC0tPgogIDxwYXRoIGQ9Ik0xMzIgMGgyNHY0OEgzNlYyNGg5NloiIGZpbGw9IiMwMGUzYmIiLz4KICAKICA8IS0tIE9yYW5nZSBNaWRkbGUgQmxvY2sgLS0+CiAgPHJlY3QgeD0iMzYiIHk9IjQ4IiB3aWR0aD0iMTIwIiBoZWlnaHQ9IjQ4IiBmaWxsPSIjY2U2YjIzIi8+CiAgCiAgPCEtLSBDeWFuIExvd2VyLU1pZGRsZSBCbG9jayAtLT4KICA8cGF0aCBkPSJNMTA4IDk2aDQ4djQ4SDM2di0yNGg3MloiIGZpbGw9IiMwMGNiZWYiLz4KICAKICA8IS0tIFRhbiBCb3R0b20gQmxvY2sgLS0+CiAgPHJlY3QgeD0iMzYiIHk9IjE0NCIgd2lkdGg9IjEyMCIgaGVpZ2h0PSI0OCIgZmlsbD0iI2QyYjQ2OCIvPgo8L3N2Zz4K";